// extracted by mini-css-extract-plugin
module.exports = {"list":"item-sets_list__tkiCH","item":"item-sets_item__7iE2e"};